import React from "react";
import { useTranslation } from "react-i18next";
import { Namespaces } from "../components/LanguageSelector";
import "./WelcomeSection.css";

export default function WelcomeSection() {
  const { t } = useTranslation();

  return (
    <div className="m-1 shadow-sm welcome-section bg-white mt-3 rounded">
      <div className="p-3">
        <p className="text-center h5 mb-4">
          {t(`${Namespaces.welcome}.welcomeHeaderText`)}
        </p>
        <p className="">
          {t(`${Namespaces.welcome}.welcomeMessage1`)}
        </p>
        {t(`${Namespaces.welcome}.welcomeMessage2`)}
      </div>
    </div>
  );
}
